import React, {Component, Fragment} from 'react';
import 'react-dropdown/style.css';
import 'react-datetime/css/react-datetime.css';
import './UnitModal.css';
import {connect} from "react-redux";
import SVG from 'react-inlinesvg';
import Datetime from 'react-datetime';
import Select from 'react-select';
import {updateUnit, createUnit, deleteUnit, deleteFileS3, fetchUnit} from "../../actions/unitActions";
import minusIcon from '../../assets/icons/red-x.svg';
import plusIcon from '../../assets/plus-icon.svg';
import externalIcon from '../../assets/external-link.svg';
import trashCan from '../../assets/trash-outline.svg'
import {objectToFormData} from '../../utils/api'
import Loading from '../Shared/Loading';
import closeicon from "../../assets/close.svg";
import {push} from "connected-react-router";
import {fetchCampaign} from "../../actions/campaignActions";
import moment from 'moment';
import $ from 'jquery';
import whiteStar from "../../assets/Star-white@3x.png";
import greyStar from "../../assets/Star-grey@3x.png";
import {logoutUser} from "../../actions/userActions";
import ToolTips from "../Shared/ToolTips";
import {withRouter} from "react-router-dom";

let initialInputValues = {
    date: '',
    date_format: '',
    celtra_url: '',
    jira_url: '',
    yieldmo_url: '',
    sf_id: '',
    epic_id: '',
    default_epic_id: false,
    media_label: '',
    creative_assets: '',
    creative_type_id: false,
    thumbnail_device_id: false,
    thumbnail: null,
    thumbnail_name: false,
    powerpoint: null,
    powerpoint_name: false,
    designer: false,
    functionalities: [],
    demo_links: [],
    s3_links: [],
    phone: false,
    tablet: false,
    desktop: false,
    tv: false,
    devices: [],
    animated: false,
    proactive_proposal: false,
    unexpanded_banner: false,
    thumbnail_url: false,
    powerpoint_url: false,
    thumbnail_alt: null,
    thumbnail_alt_url: false,
    disable_input: false,
    count_box: false,
    banner_type: 'html5',
    bulk_thumbnails: [],
    creative_refresh: false,
    meta_data: {
        meta_key: false,
        meta_value: false
    },
    creative_subcategories: [],
    roadside_billboard: false,
    commuter_hub: false,
    brand: false,
    seller: false,
    name: false,
    verticals: [],
    create_campaign: false
};

class UnitModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            feedback: false,
            errors: [],
            inputOptions: {
                designers: [],
                functionalities: [],
                creative_types: [],
                demo_types: [],
                creative_types_demo_links: [],
                thumbnail_device_types: [],
                creative_subcategories: []
            },
            inputValues: initialInputValues,
            creative_type: false,
            step: 1,
            showCreativeTypes: 3,
            liveDisable: false,
            mockDisable: false
        };
        this.validationMessageRef = React.createRef();
        this.changeStep = this.changeStep.bind(this);
        // this.handleRadioChange = this.handleRadioChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleMultiCheckboxChange = this.handleMultiCheckboxChange.bind(this);
        this.getCreativeType = this.getCreativeType.bind(this);
        this.getUnitType = this.getUnitType.bind(this);
        this.addDemoRow = this.addDemoRow.bind(this);
        this.deleteDemoRow = this.deleteDemoRow.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.getDemoType = this.getDemoType.bind(this);
        this.getCreativeDemoTypeLinks = this.getCreativeDemoTypeLinks.bind(this);
        this.deleteS3 = this.deleteS3.bind(this);
        this.changeEpicId = this.changeEpicId.bind(this);

    };

    closeModal(e) {
        if (e.keyCode === 27) {
            this.props.toggleModal('unit', false)
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.closeModal);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.closeModal);
    }

    componentWillMount() {
        let unit = this.props.unit;
        let io = this.props.inputOptions.units;
        let fullName = "";
        let devices = [];
        if(this.props.user !== undefined){
            fullName = this.props.user.first_name +" "+ this.props.user.last_name;
            io.designers.map(des => {
                if(des.email === this.props.user.email){
                    fullName = des.name;
                }
            })
        }
        let designers = io.designers.map(function (item) {
            return {
                label: item.name,
                value: item.name
            }
        });
        const inputOptions = {
            designers: designers,
            functionalities: Array.isArray(io.functionalities) ? io.functionalities : [],
            creative_types: Array.isArray(io.creative_types) ? io.creative_types : [],
            demo_types: Array.isArray(io.demo_types) ? io.demo_types.map(t => ({label: t.name, value: t.id})) : [],
            creative_types_demo_links: Array.isArray(io.creative) ? io.creative.map(n => ({
                label: n.name,
                value: n.demo_type_id,
                creative_type_id: n.creative_type_id,
                demo_type_id: n.demo_type_id
            })) : [],
            thumbnail_device_types: Array.isArray(io.thumbnail_device_types) ? io.thumbnail_device_types.map(t => ({
                label: t.name,
                value: t.thumbnail_type_id,
                creative_type_id: t.creative_type_id,
                thumbnail_type_id: t.thumbnail_type_id
            })) : [],
            creative_subcategories: Array.isArray(io.creative_subcategories) ? io.creative_subcategories : []
        };

        const inputValues = Object.assign({}, this.state.inputValues);
        if(this.props.create){
            if(fullName !== ""){
                inputValues.designer ={
                    label: fullName,
                    value: fullName
                };
            }
            let now = moment().format('YYYY-MM-DD 12:00:00');
            let date = moment().format('MMMM YYYY');
            inputValues.date = now;
            inputValues.date_format = date;
        }
        if(this.props.create && this.props.flow){
            inputValues.create_campaign = this.props.flow;
            inputValues.brand = {
                id: this.props.campaign.brand_id,
                label: this.props.campaign.brand_value,
                value: this.props.campaign.brand_value
            };
            inputValues.hide_brand = this.props.campaign.hide_brand;
            inputValues.name = {
                id: this.props.campaign.id,
                label: this.props.campaign.name,
                value: this.props.campaign.name,
            };
            inputValues.seller = {
                id: this.props.campaign.seller_id,
                label: this.props.campaign.seller_value,
                value: this.props.campaign.seller_value,
            };
            inputValues.verticals = this.props.campaign.verticals;
            inputValues.subcategory = this.props.campaign.subcategory;
        }
        if (!this.props.create) {
            inputValues.id = unit.id;
            inputValues.cid = unit.cid;
            inputValues.celtra_url = unit.celtra_url;
            inputValues.jira_url = unit.jira_url;
            // inputValues.epic_id = unit.EPIC_ID.replace('TC-', '');
            inputValues.epic_id = unit.EPIC_ID;
            inputValues.default_epic_id = unit.default_epic_id;
            inputValues.creative_assets_url = unit.creative_assets_url;
            inputValues.yieldmo_url = unit.yieldmo_url;
            inputValues.sf_id = unit.sf_id;
            inputValues.date = moment(unit.date).format('YYYY-MM-DD 12:00:00');
            inputValues.date_format = moment(unit.date).format('MMMM YYYY');
            inputValues.creative_type_id = unit.creative_type_id;
            inputValues.designer = {};
            inputValues.designer.value = unit.designer;
            inputValues.designer.label = unit.designer;
            if(unit.thumbnail_device_id === 9){
                unit.thumbnail_device_id = 1;
            }
            if(unit.thumbnail_device_id === 10){
                unit.thumbnail_device_id = 7;
            }
            inputValues.thumbnail_device_id = unit.thumbnail_device_id;
            inputValues.thumbnail_device = unit.thumbnail_device;
            inputValues.count_box = unit.display_banner_count;
            inputValues.banner_type = unit.display_banner_type;
            inputValues.bulk_thumbnails = [];
            inputValues.functionalities = unit.functionalities.map(f => f.id)
            inputValues.media_label = unit.media_label;
            inputValues.creative_subcategories = unit.creative_subcategories.map(cs => cs.id)
            inputValues.demo_links = unit.demo_links.map(d => ({
                id: d.id,
                demo_type: {
                    label: d.demo_type,
                    value: d.demo_type_id
                },
                creative_id: d.creative_id,
                tagmaker_link: d.tagmaker_link,
                notes: d.notes,
                url: d.url,
                bestInClass: d.best_in_class,
            }));
            inputValues.s3_links = unit.s3_links.map(s => ({
                id: s.id,
                ad_size:{
                    label: s.ad_size,
                    value: s.demo_type_id
                },
                s3_url: s.s3_location,

                file_name: s.file_name.split('/')[1],
                notes: s.note,
                bestInClass: s.best_in_class
            }));

            inputValues.phone = unit.phone;
            inputValues.tablet = unit.tablet;
            inputValues.desktop = unit.desktop;
            inputValues.ctv = unit.ctv;
            inputValues.roadside_billboard = unit.roadside_billboard;
            inputValues.commuter_hub = unit.commuter_hub;

            let phone  = inputValues.phone === 'true' ? devices.push('phone') : '';
            phone = inputValues.tablet === 'true' ? devices.push('tablet') : ''
            phone = inputValues.desktop === 'true' ? devices.push('desktop') : ''
            phone = inputValues.ctv === 'true' ? devices.push('ctv') : ''
            phone = inputValues.roadside_billboard === 'true' ? devices.push('roadside_billboard') : ''
            phone = inputValues.commuter_hub === 'true' ? devices.push('commuter_hub') : '';
            inputValues.devices = devices
            inputValues.animated = unit.animated;
            inputValues.creative_refresh = unit.creative_refresh;
            inputValues.proactive_proposal = unit.proactive_proposal;
            inputValues.unexpanded_banner = unit.unexpanded_banner;
            inputValues.thumbnail_url = unit.thumbnail;
            inputValues.thumbnail_alt_url = unit.thumbnail_alt;
            inputValues.powerpoint_url = unit.ppt_location;
            inputValues.thumbnail_alt_url = unit.thumbnail_alt;

            if(unit.meta !== undefined && unit.meta.length === 1){
                inputValues.meta_data = unit.meta[0]
            }else {
                if(inputValues.creative_type_id === 499 && unit.s3_links.length >= 1){
                    inputValues.meta_data = {
                        meta_key: 'video_deliverable',
                        meta_value: 'static'
                    }
                }else{
                    inputValues.meta_data = {
                        meta_key: false,
                        meta_value: false
                    }
                }
            }

        } else {
            inputValues.cid = this.props.campaign.id;
        }
        // getUnitType() {
        //     let creative_type_id = this.state.inputValues.creative_type_id;
        //     let type = this.state.inputOptions.creative_types.filter(t => t.id === creative_type_id);
        //     if (type.length) {
        //         return type[0].unit_type;
        //     }
        // }

        const state = {};
        state.inputOptions = inputOptions;
        inputOptions.functionalities.filter(f => {
            if(f.creative_type_id === inputValues.creative_type_id){
                if(f.name === inputValues.media_label){
                    inputValues.media_label = {
                        label: f.name,
                        value: f.name,
                        id: f.id,
                        creative_type_id: inputValues.creative_type_id
                    };
                }
            }
        })
        let liveDisable = false;
        let mockDisable = false;
        if(!this.props.create){
            let creative_type_id = unit.creative_type_id;
            let type = state.inputOptions.creative_types.filter(t => t.id === creative_type_id);
            mockDisable = !this.props.create && type[0].unit_type === 'live';
            liveDisable = !this.props.create && type[0].unit_type === 'mock';
        }
        state.inputValues = inputValues;
        state.step = this.props.step;
        state.mockDisable = mockDisable;
        state.liveDisable = liveDisable;
        this.setState(state);
        // $("html, body").animate({scrollTop: 0}, 300);
    }

    handleSubmit = (e) => {
        e.preventDefault();
    };

    handleImageChange = (e, id = "") => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            let reader = new FileReader();
            let file = e.target.files[0];
            let state = this.state;
            let adSizes = [...this.state.inputOptions.demo_types];
            reader.readAsDataURL(file)
            if(state.inputValues.banner_type === "standard" && e.target.name === 's3_links' || state.inputValues.creative_type_id === 499 && e.target.name === 's3_links'){
                let label = "";
                let file_name = e.target.files[0].name
                if(file_name.includes('_')){
                    let file = file_name.split("_");
                    let size = file[file.length - 1].split(".");
                    let fileName = size[0];
                    adSizes.filter(d => {
                        if(d.label === fileName){
                            return label = d;
                        }
                    })
                }
                let thumb_obj = {
                    file: "",
                    url: ''
                }
                let temp = state.inputValues.bulk_thumbnails !== undefined ? [...state.inputValues.bulk_thumbnails] : [];
                reader.onloadend = () => {
                    thumb_obj.file = file;
                    thumb_obj.url = reader.result;
                    temp.push(thumb_obj);
                    state.inputValues.bulk_thumbnails = temp;
                    state.inputValues.s3_links[id].file_name  = file.name;
                    state.inputValues.s3_links[id].ad_size = label;
                    this.setState(state);
                };
            }else{
                reader.onloadend = () => {
                    state.inputValues.thumbnail = file;
                    state.inputValues.thumbnail_url = reader.result;
                    state.inputValues.thumbnail_name = file.name;
                    this.setState(state);
                };
            }
        }
    };
    bulkReader = (files, cb) => {
        let temp = [];
        let c = 0;
        for (let f in files) {
            let thumb_obj = {
                file: "",
                url: ''
            }
            let file = files[f];
            const reader = new FileReader();
            if(files.hasOwnProperty(f)){
                reader.readAsDataURL(file)
                reader.onload = (e) => {
                    thumb_obj.file = file;
                    thumb_obj.url = reader.result;
                    temp.push(thumb_obj)
                    c++
                    if(c === files.length){
                        cb(temp)
                    }
                }
            }
        }
    }
    s3BulkUpload = (e) => {
        e.preventDefault();
        let inputValues = Object.assign({}, this.state.inputValues);
        let s3Links = [...this.state.inputValues.s3_links.slice()]
        let prevThumbnails = [...this.state.inputValues.bulk_thumbnails];
        let adSizes = [...this.state.inputOptions.demo_types];
        if(e.target.files && e.target.files.length >= 1){
            let files = e.target.files;
              this.bulkReader(files, (res)=>{
                  prevThumbnails.push(...res);
                  inputValues.bulk_thumbnails = prevThumbnails;
                      for (let i = 0; i < res.length ; i++) {
                          let name = res[i].file.name
                          let label = "";
                          if(name.includes('_')){
                              let file = name.split("_");
                              let size = file[file.length - 1].split(".");
                              let fileName = size[0];
                              adSizes.filter(d => {
                                  if(inputValues.creative_type_id !== 499) {
                                      if (d.label === fileName) {
                                          return label = d;
                                      }
                                  }else{
                                      return label = "";
                                  }
                              })
                          }

                          s3Links.push({
                              id: false,
                              ad_size: label,
                              file_name: res[i].file.name,
                              notes: '',
                          });
                      }
                  if(inputValues.banner_type !== "standard" && inputValues.creative_type_id === 499){
                      inputValues.banner_type = null;
                  }
                  inputValues.count_box = s3Links.length;
                  inputValues.s3_links = s3Links;
                  this.setState({
                      inputValues
                  })
              })
        }
    }

    handleFileChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            let inputValues = Object.assign({}, this.state.inputValues);
            inputValues[e.target.name] = e.target.files[0];
            if(e.target.name === "powerpoint"){
                inputValues['powerpoint_name'] = e.target.files[0].name;
            }
            this.setState({inputValues});
        }
    };

    addDemoRow = () => {
        let inputValues = Object.assign({}, this.state.inputValues);
        let demoLinks = this.state.inputValues.demo_links.slice();
        let s3_links = this.state.inputValues.s3_links.slice()
        if(inputValues.banner_type === 'standard'){
            if(s3_links.length === 0 || this.state.inputValues.bulk_thumbnails === undefined){
                s3_links.push({});
                inputValues.count_box = s3_links.length;
            }else if(inputValues.meta_data.meta_value === 'link'){
                for (let i = 0; i < demoLinks.length; i++) {
                    if (demoLinks[i]['url'] === '' || demoLinks[i]['demo_type_id'] === '') {
                        return;
                    }
                }
                demoLinks.push({
                    id: false,
                    demo_type_id: false,
                    url: '',
                    notes: '',
                    creative_id: '',
                    tagmaker_link: ''
                });
                inputValues.count_box = demoLinks.length;
                inputValues.demo_links = demoLinks;
            } else{
                s3_links.push({
                    id: false,
                    ad_size: false,
                    file_name: "",
                    notes: ''
                });
                inputValues.count_box = s3_links.length;
            }
            inputValues.s3_links = s3_links;
            this.setState({
                inputValues
            })
        }
        else{
            for (let i = 0; i < demoLinks.length; i++) {
                if (demoLinks[i]['url'] === '' || demoLinks[i]['demo_type_id'] === '') {
                    return;
                }
            }
            if(this.state.inputValues.creative_type_id === 490 || this.state.inputValues.creative_type_id === 494 || this.state.inputValues.creative_type_id === 504){
                let obj ={
                    creative_type_id: this.state.inputValues.creative_type_id,
                    demo_type: 1,
                    label: 'Phone',
                    value: 1
                }
                demoLinks.push({
                    id: false,
                    demo_type: obj,
                    url: '',
                    notes: '',
                    creative_id: '',
                    tagmaker_link: '',
                    bestInClass: 0
                });
            }else{
                demoLinks.push({
                    id: false,
                    demo_type_id: false,
                    url: '',
                    notes: '',
                    creative_id: '',
                    tagmaker_link: '',
                    bestInClass: 0
                });
            }
            if(this.state.inputValues.creative_type_id === 10 || this.state.inputValues.creative_type_id === 499){
                inputValues.count_box = demoLinks.length;
            }
            inputValues.demo_links = demoLinks;
            this.setState({
                inputValues
            })
        }

    };

    deleteDemoRow = (key, name = "") => {
        let inputValues = Object.assign({}, this.state.inputValues);
        let demoLinks = this.state.inputValues.demo_links.slice();
        let s3Links = this.state.inputValues.s3_links.slice();
        if(inputValues.banner_type === 'standard' || inputValues.creative_type_id === 499){
            let thumbnail_array = this.state.inputValues.bulk_thumbnails.slice();
            if(this.props.create){
                if(inputValues.meta_data.meta_key === false){
                    demoLinks.splice(key, 1);
                    inputValues.count_box = inputValues.count_box - 1;
                    inputValues.demo_links = demoLinks;
                    s3Links.splice(key, 1);
                    inputValues.s3_links = s3Links;
                    thumbnail_array.splice(key, 1);
                    inputValues.bulk_thumbnails = thumbnail_array;

                }else{
                    // let thumbnail_array = this.state.inputValues.bulk_thumbnails.slice();
                    if(inputValues.banner_type === 'standard' || inputValues.meta_data.meta_value === "static"){
                        thumbnail_array.splice(key, 1);
                        inputValues.bulk_thumbnails = thumbnail_array;
                        s3Links.splice(key, 1);
                        inputValues.s3_links = s3Links;
                    }else{
                        demoLinks.splice(key, 1);
                        inputValues.demo_links = demoLinks;
                    }

                    inputValues.count_box = inputValues.count_box - 1;
                }
            }else if(!this.props.create || this.state.inputValues.bulk_thumbnails.length > 0){
                let thumbnail_array = this.state.inputValues.bulk_thumbnails.slice();
                let k = thumbnail_array.findIndex(n => n.file.name === name && n.file.id === undefined);
                if(k !== -1){
                    thumbnail_array.splice(k, 1);
                    inputValues.bulk_thumbnails = thumbnail_array;
                }
                if(inputValues.banner_type === 'standard' || inputValues.meta_data.meta_value === "static"){
                    thumbnail_array.splice(k, 1);
                    inputValues.bulk_thumbnails = thumbnail_array;
                    s3Links.splice(key, 1);
                    inputValues.s3_links = s3Links;
                }else{
                    demoLinks.splice(key, 1);
                    inputValues.demo_links = demoLinks;
                }
                inputValues.count_box = inputValues.count_box - 1;
            }

        }else{
            demoLinks.splice(key, 1);
            inputValues.count_box = inputValues.count_box - 1;
            inputValues.demo_links = demoLinks;
        }
        this.setState({
            inputValues
        })
    };

    handleKeyDown = name => e => {
        const {inputValue} = this.state;
        if (!inputValue) return;
        let inputValues = Object.assign({}, this.state.inputValues);
        inputValues[name] = inputValues[name];
        switch (e.key) {
            case 'Enter':
            case 'Tab':
                this.setState({
                    inputValue: '',
                });
                e.preventDefault();
        }
    };

    handleSelectChange = (name, idx = false, key = false) => newValue => {
        let inputValues = Object.assign({}, this.state.inputValues);
        if (idx !== false && key !== false) {
            inputValues[name][idx][key] = newValue;
        } else {
            inputValues[name] = newValue;
        }

        this.setState({
            inputValues
        });
    };

    changeStep = (step) => {
        let stepflow = 2;
        let showCreativeTypes = 3;
        let inputValues = Object.assign({}, this.state.inputValues);
        if(step === 1){
            // if(!this.props.create){
                if(this.getUnitType() === 'mock'){
                    showCreativeTypes = 1
                }else if(this.getUnitType() === 'live'){
                    showCreativeTypes = 2
                }
            // }
            if(this.props.create){
                inputValues.creative_type_id = false
                inputValues.thumbnail_device_id = false
            }
            if(this.props.flow){
                stepflow = 2
            }
        }
        if (step === 2) {
            if(step === 2 && !this.props.create){
                stepflow = 1;
            }
            if(this.props.flow){
                stepflow = 3
            }
            if(this.state.inputValues.creative_type_id === 499){
                let meta = {
                    "meta_key": "video_deliverable",
                    "meta_value": "link"
                }
                inputValues.meta_data = meta;
            }
            if(this.state.inputValues.creative_type_id === 500){
                let data = {
                    meta_key: 'DOOH_deliverable',
                    meta_value: 'static'
                }
                inputValues.meta_data = data;
            }
            if (this.state.inputValues.creative_type_id === false) {
                alert('Please select a creative format');
                return false;
            }
        }
        if (this.state.inputValues.creative_type_id === 2 || this.state.inputValues.creative_type_id === 9) {
            if (this.state.inputValues.thumbnail_device_id !== false) {
                inputValues.thumbnail_device_id = true
                inputValues.demo_links.map(dt => {
                    dt.demo_type = {}
                })
            }
        }
        if (this.state.inputValues.creative_type_id === 490 || this.state.inputValues.creative_type_id === 494 || this.state.inputValues.creative_type_id === 504) {
            inputValues.thumbnail_device_id = 9;
        }else{
            inputValues.thumbnail_device_id = false;
        }
        // this.props.changeSteps(3);
        if(this.state.inputValues.creative_type_id !== false){
            this.props.getCampaignValues(this.state.inputValues, stepflow, 'unit');
        }
        this.setState({
            step: step,
            checked: false,
            feedback: false,
            showCreativeTypes,
            inputValues
        });
    };

    handleRadioChange = (e) => {
        const value = e.target.value;
        let inputValues = Object.assign({}, this.state.inputValues);
        inputValues[e.target.name] = parseInt(value, 0);
        let meta = e.target.getAttribute("data-meta");
        if(meta === "meta"){
            let keys = e.target.name;
            let metaObject = {}
            metaObject['meta_key'] = keys
            metaObject['meta_value'] = value
            inputValues.meta_data = metaObject;
            if(value === "link"){
                inputValues.count_box = inputValues.demo_links.length;
            }else{
                inputValues.count_box = inputValues.s3_links.length;
            }
        }
        if (e.target.name === 'creative_type_id') {
            inputValues.functionalities = [];
        }
        if(e.target.name === 'banner_type'){
            inputValues.banner_type = value;
            if(value === 'html5'){
                inputValues.count_box = inputValues.demo_links.length;
            }else{
                inputValues.count_box = inputValues.s3_links.length;
            }
        }
        if (value === '492') {
            this.state.inputOptions.functionalities.forEach(function (element) {
                if (element.creative_type_id === 492 && element.name === "Advanced Predictive Creative") {
                    inputValues.functionalities.push(element.id);
                }
            });
        }
        if (value === '493') {
            this.state.inputOptions.functionalities.forEach(function (element) {
                if (element.creative_type_id === 493 && element.name === "Advanced Predictive Creative") {
                    inputValues.functionalities.push(element.id);
                }
            });
        }
        if(value === '504'){
            this.state.inputOptions.functionalities.forEach(function (element) {
                if (element.creative_type_id === 504 && element.name === "Gamification") {
                    inputValues.functionalities.push(element.id);
                }
            });
        }
        if(value === '505'){
            this.state.inputOptions.functionalities.forEach(function (element) {
                if(element.creative_type_id === 505 && element.name === "Gamification"){
                    inputValues.functionalities.push(element.id);
                }
            });
        }
        this.setState({inputValues: inputValues});

    }

    handleTextChange(e, idx = false, prop = false) {
        let value = e.target.value;
        let inputValues = Object.assign({}, this.state.inputValues);
        // let base = process.env.REACT_APP_JIRA_BASE;
        let base = "CAM2-";
        const re = /^[0-9\b]+$/;
        if (idx !== false && prop !== false) {
            inputValues[e.target.name][idx][prop] = value;
            this.setState({inputValues});
        } else {
            if(e.target.name === 'epic_id'){
                if(value.includes('CAM2-')){
                    value = value.replace('CAM2-', '');
                }
                if (e.target.value === ''|| re.test(value)) {
                    let text = value.replace(base, "");
                    let v = text.replace(/[^a-zA-Z0-9\-]/g, '');
                    inputValues[e.target.name] = v;
                }
            }else if(e.target.name === 'media_label'){
                let regex = value.replace(/[^a-zA-Z0-9\-\s]/g, '').trim();
                inputValues[e.target.name] = regex;
            }else if(e.target.name === 'sf_id'){
                if(this.props.create){
                    const re = /^[0-9\b]+$/;
                    if (e.target.value === '' || re.test(value)) {
                        inputValues[e.target.name] = value
                    }
                }else{
                    inputValues[e.target.name] = value
                }

            }
            else{
                inputValues[e.target.name] = value;
            }
            this.setState({inputValues});
        }
    }
    addToFavorites = (e, idx = false, prop = false) => {
        const value = e.currentTarget.getAttribute('name');
        let inputValues = Object.assign({}, this.state.inputValues);
        if (idx !== false && prop !== false) {
            if(inputValues[value][idx][prop] === 1){
                inputValues[value][idx][prop] = 0;
            }else{
                inputValues[value][idx][prop] = 1;
            }
        }
        this.setState({inputValues});
    }

    handleDateChange(moment, name) {
        if (typeof moment.format === 'function') {
            let inputValues = Object.assign({}, this.state.inputValues);
            inputValues[name] = moment.format('YYYY-MM-DD 12:00:00');
            inputValues['date_format'] = moment.format('MMMM YYYY');
            this.setState({
                inputValues: inputValues
            });
        }
    }

    handleMultiCheckboxChange(e) {
        const {name, checked} = e.target;
        const value = parseInt(e.target.value);
        let inputValues = this.state.inputValues;
        let arr = inputValues[name];
        let inputValueName = "";
        let baseName = "";
        let base = undefined;
        if(name === 'functionalities'){
            inputValueName = this.state.inputOptions.functionalities.find(o => {
                return o.id == value && o.creative_type_id == this.state.inputValues.creative_type_id
            });
            baseName = inputValueName.name.includes('-') ? inputValueName.name.split('-')[0].trim() : false;
            base = this.state.inputOptions.functionalities.find(o => {
                return o.name == baseName && o.creative_type_id == this.state.inputValues.creative_type_id
            });
        }
        if(name === 'devices'){
            if (checked) {
                arr = [...arr, e.target.value];
            } else {
                arr = arr.filter(el => el !== e.target.value);
                if(!arr.includes(inputValues.media_label.id)){
                    inputValues.media_label = '';
                }
            }
        }else{
            if (checked) {
                arr = [...arr, value];
            } else {
                arr = arr.filter(el => el !== value);
                if(inputValues.media_label !== null){
                    if(!arr.includes(inputValues.media_label.id)){
                        inputValues.media_label = '';
                    }
                }
            }
        }
        if (typeof base !== 'undefined') {
            if (checked) {
                if (!arr.includes(base.id)) {
                    arr = [...arr, base.id];
                }
            } else {
                let otherOptions = this.state.inputOptions.functionalities.filter(o => {
                    return arr.includes(o.id)
                });

                let options = otherOptions.filter(o => {
                    return o.name.indexOf(baseName + ' - ') !== -1;
                });

                if (options.length === 0) {
                    arr = arr.filter(el => el !== base.id);
                }

            }
        }

        inputValues[name] = arr;

        this.setState({inputValues});
    }

    handleCheckboxChange(e) {
        const {name, checked, value} = e.target;
        let inputValues = Object.assign({}, this.state.inputValues);

        inputValues[name] = checked ? "true" : "false";

        this.setState({inputValues});
    }

    changeEpicId(e){
        let dei = process.env.REACT_APP_JIRA_DEFAULT_EPIC_ID;
        // let dei = 'TC-131'
        // let base = process.env.REACT_APP_JIRA_BASE;
        let base = "CAM2-";
        let epicId = dei.replace(base, "");
        epicId = epicId.replace(/[^a-zA-Z0-9\-]/g, '');
        if(e.target.checked){
            this.setState(prevState => ({
                inputValues: {
                    ...prevState.inputValues,
                    epic_id: epicId,
                    default_epic_id: true,
                    disable_input: true
                }
            }))
        }else{
            this.setState(prevState => ({
                inputValues:{
                    ...prevState.inputValues,
                    epic_id: '',
                    default_epic_id: false,
                    disable_input: false
                }
            }))
        }
    }

    handleSave(addNew) {
        let inputValues = this.state.inputValues;
        this.setState({s3Message: ""});
        let type = this.getUnitType();
        // let base = process.env.REACT_APP_JIRA_BASE;
        let base = "CAM2-";
        if(type === "mock"){
            let epic = this.state.inputValues.epic_id;
            if(epic.includes("CAM2-")){
                base = ""
            }
            inputValues.epic_id = base + this.state.inputValues.epic_id;
        }
        if(inputValues.creative_type_id === 499 || inputValues.creative_type_id === 10){
            if(inputValues.meta_data.meta_value === "static" || inputValues.banner_type === "standard"){
                inputValues.demo_links = [];
                inputValues.count_box = inputValues.s3_links.length;
            }else{
                inputValues.s3_links = [];
                inputValues.bulk_thumbnails = []
                inputValues.count_box = inputValues.demo_links.length;
            }
            this.setState({inputValues})
        }
        const data = objectToFormData(inputValues);
        if (this.props.create) {
            this.props.dispatch(createUnit(this.getUnitType(), data)).then(res => {
                if (addNew) {
                    this.props.dispatch(fetchCampaign(this.state.inputValues.cid));
                    let epic = this.state.inputValues.epic_id !== false ? this.state.inputValues.epic_id.replace('CAM2-', '') : false;
                    let saved = {
                        cid: res.data.cid,
                        designer: this.state.inputValues.designer,
                        date_format: this.state.inputValues.date_format,
                        date: this.state.inputValues.date,
                        epic_id: epic,
                        sf_id : this.state.inputValues.sf_id !== null ? this.state.inputValues.sf_id : null,
                    }
                    this.setState({
                        inputValues: {
                            ...initialInputValues,
                            cid: saved.cid,
                            designer: saved.designer,
                            date_format: saved.date_format,
                            date: saved.date,
                            epic_id: saved.epic_id,
                            sf_id : saved.sf_id,
                        },
                        step: 1,
                        errors: [],
                        feedback: 'You have successfully created a unit.',
                    });
                    this.props.changeSteps(1)
                } else {
                    this.setState({
                        errors: []
                    });
                    this.props.toggleModal('unit', false);
                    this.props.dispatch(push('/' + this.getUnitType() + '/' + res.data.id))
                    this.props.dispatch(fetchUnit(this.getUnitType(), res.data.id))
                }
            }, err => {
                this.setState({
                    errors: err.error_stack,
                    feedback: false,
                }, () => {
                    let item = this.validationMessageRef.current;
                    if(item !== null){
                        item.scrollIntoView(true, {behavior: "smooth"});
                    }
                });
            });
        } else {
            this.props.dispatch(updateUnit(this.getUnitType(), this.state.inputValues.id, data)).then(res => {
                this.props.toggleModal('unit', false);
            }, err => {
                this.setState({
                    errors: err.error_stack,
                    feedback: false,
                }, () => {
                    let item = this.validationMessageRef.current;
                    if(item !== null){
                        item.scrollIntoView(true, {behavior: "smooth"});
                    }
                });
            });
        }
        $("html, body").animate({ scrollTop: 0 }, 300);
    }

    getCreativeType() {
        let creative_type_id = this.state.inputValues.creative_type_id;

        let type = this.state.inputOptions.creative_types.filter(t => t.id === creative_type_id);

        if (type.length) {
            return type[0].name;
        }
    }

    getUnitType() {
        let creative_type_id = this.state.inputValues.creative_type_id;
        let type = this.state.inputOptions.creative_types.filter(t => t.id === creative_type_id);
        if (type.length) {
            return type[0].unit_type;
        }
    }

    handleDelete() {
        const res = window.confirm("Are you sure you want to delete?");
        if (res) {
            this.props.dispatch(deleteUnit(this.getUnitType(), this.state.inputValues.id, this.state.inputValues.cid));
        }
    }

    deleteS3(file_type) {
        const res = window.confirm("Are you sure you want to delete this file?");

        if (res) {
            this.props.dispatch(deleteFileS3(this.getUnitType(), this.state.inputValues.id, this.props.unit, file_type)).then(res => {
                if (file_type === 't') {
                    this.setState(prevState => ({
                        s3Message: res.data,
                        inputValues: {
                            ...prevState.inputValues,
                            thumbnail_alt_url: null
                        }
                    }));
                } else {
                    this.setState(prevState => ({
                        s3Message: res.data,
                        inputValues: {
                            ...prevState.inputValues,
                            powerpoint_url: null
                        }
                    }));
                }
            });
        }
    }

    getDemoType() {
        let creative_id = this.state.inputValues.creative_type_id;
        let cd = this.state.inputOptions.creative_types_demo_links.filter(cd => cd.creative_type_id === creative_id && cd.label !== null );
        if(creative_id === 493){
            let apc_dt = cd.filter(apc_dt => apc_dt.label.includes('x'));
            cd = apc_dt
        }
        if (creative_id === 490 || creative_id === 494) {
            cd = cd.filter(dt => dt.label == 'Phone');
        }
        if (creative_id === 499) {
            cd = cd.filter(d => !d.label.includes('x') && !d.label.includes('Commuter Hub') && !d.label.includes('Roadside'))
        }
        if(creative_id === 10){
            cd = cd.filter(dt => dt.label.includes('x'))
        }
        if(creative_id === 8){
            cd = cd.filter(dt => dt.label !== 'Desktop');
        }
        cd.sort((a,b) => (a.value > b.value) ? 1 : -1)
        return cd;
    }

    getCreativeDemoTypeLinks() {
        let ctdl = this.state.inputOptions.creative_types_demo_links.filter(ctdl => ctdl.label != 'Cross Device');
        let thumb_option = ctdl.filter(n => n.creative_type_id === this.state.inputValues.creative_type_id);
        return thumb_option;
    }
    ifBulk = () => {
        let result = false;
        if(this.state.inputValues.creative_type_id === 499 && this.state.inputValues.meta_data.meta_value === 'static'){
            result = true;
        }
        if(this.state.inputValues.creative_type_id === 10 && this.state.inputValues.banner_type === 'standard'){
            result = true;
        }
        // if(this.state.inputValues.creative_type_id === 500){
        //     result = true;
        // }
        return result
    }
    changeClass = (status, type) => {
        let inputValues = {...this.state.inputValues}
        inputValues['creative_type_id'] = false;
        if(type === 'mock' && this.state.mockDisable){
            return
        }
        else if(type === 'live' && this.state.liveDisable){
            return
        }else{
            this.setState({
                showCreativeTypes: status,
                creative_type: type,
                inputValues
            });
        }
    }
    filterMediaLabelOptions = () => {
        let options = [];
        let value = []
        this.state.inputOptions.functionalities.filter(f => {
            if(f.creative_type_id === this.state.inputValues.creative_type_id){
                if(f.name !== "Expandable" && f.name !== "Interstitial" && f.name !== "Gamification"){
                    if(this.state.inputValues.functionalities.length){
                        if(this.state.inputValues.functionalities.includes(f.id)){
                            options.push(f)
                        }
                    }else{
                        options.push(f)
                    }
                }
            }
        })
        return(
            <div className="third--row row-border">
                <p className="col--unit-header primary">Primary Functionality <span className="required--fields">*</span></p>
                <div className="second--row-inner">
                    <Select
                        autoComplete="off"
                        onChange={this.handleSelectChange('media_label')}
                        options={options}
                        value={this.state.inputValues.media_label}
                        onKeyDown={this.handleKeyDown('media_label')}
                        className="react-select"
                        classNamePrefix="react-select--dd"
                    />
                </div>
            </div>
        )

    }
    getThumbnailDevices(){
        let array = ['Phone', 'Tablet', 'Desktop', 'CTV', 'Horizontal Phone', 'Horizontal iPhone X', 'Horizontal Tablet', 'iPhone X' ]
        let state = this.state.inputOptions.thumbnail_device_types.filter(thumb => thumb.thumbnail_type_id !== 4 && thumb.creative_type_id === this.state.inputValues.creative_type_id);
        let filtered = state.filter(t => {
            if(t.label === "iPhone X"){
                t.label = 'Phone';
                t.thumbnail_type_id = 1;
                t.value = 1;
            }
            if(t.label === "Horizontal iPhone X"){
                t.label = 'Horizontal Phone';
                t.thumbnail_type_id = 7;
                t.value = 7;
            }
            if(t.label !== "iPhone X" && t.label !== "Horizontal iPhone X") {
                return t;
            }
        } )
        let result = filtered.reduce((unique, o) => {
            if(!unique.some(obj => obj.label === o.label && obj.value === o.value)) {
                unique.push(o);
            }
            return unique;
        },[]);
        let sorted = result.sort((a,b) => {
            const indexA = array.findIndex(type => a.label === type);
            const indexB = array.findIndex(type => b.label === type);
            return indexA - indexB; // to get positive, 0, negative number for the sort callback.
        });
        return(
        sorted.map((thumb,key) => (
            <li key={key}>
                <label htmlFor={thumb.label}>
                    <input
                        type="radio"
                        name="thumbnail_device_id"
                        value={thumb.thumbnail_type_id}
                        checked={this.state.inputValues.thumbnail_device_id.value === undefined ? this.state.inputValues.thumbnail_device_id === thumb.thumbnail_type_id : this.state.inputValues.thumbnail_device_id.value === thumb.thumbnail_type_id}
                        id={thumb.label}
                        onChange={this.handleRadioChange}
                    />
                    {thumb.label}</label>
            </li>
        ))
        )
    }

    render() {
        const values = this.state.inputValues;
        const campaign = this.props.campaign;
        // let base = process.env.REACT_APP_JIRA_BASE;
        let base = "CAM2-";
        let ct = values.creative_type_id === 10 || values.creative_type_id === 499;
        let step = this.props.flow ? 2 : 1;
        let type = this.getCreativeType() !== 'Display'
            && this.getCreativeType() !== 'Digital Out Of Home'
            && this.getCreativeType() !== 'Augmented Reality'
            && this.getCreativeType() !== 'Native High Impact';
        return (
            <React.Fragment>
                <div className="live-unit-wrapper">
                    <form onSubmit={(e) => e.preventDefault(e)}>
                        {this.state.s3Message &&
                            <p className="s3-message">{this.state.s3Message}</p>
                        }
                        {this.state.errors &&
                        <ul className="error-list" id="error_message" ref={this.validationMessageRef}>
                            {this.state.errors.map((error, key) => (
                                <li key={key}>{error.msg}</li>
                            ))}
                        </ul>
                        }
                        {this.state.feedback &&
                            <ul className="feedback-list">
                                <li>{this.state.feedback}</li>
                            </ul>
                        }
                        <div style={{display: this.state.step === 1 ? 'block' : 'none'}}>
                            <div className="modal-header">
                                <h1>{this.props.create ? 'Add Creative' : 'Edit Creative'}</h1>
                                <p>{this.props.campaign ? this.props.campaign.name : ""}</p>
                            </div>
                            <div className="unit-type-container">
                                <p className="unit--label-style unit--one-label">Unit Type</p>
                                <div className="unit-type-container-col">
                                    <input type="radio" id="c_mock" value="mock" name="creative_type" disabled={this.state.mockDisable} defaultChecked={!this.props.create && this.getUnitType() === 'mock'} />
                                    <label htmlFor="c_mock" className="unit-type-label" onClick={(e) => {this.changeClass(1, 'mock')}}>
                                        Mock Up
                                    </label>
                                </div>
                                    <div className="unit-type-container-col">
                                        <input type="radio" id="c_live" value="live" name="creative_type" disabled={this.state.liveDisable}  defaultChecked={!this.props.create && this.getUnitType() === 'live'}/>
                                        <label htmlFor="c_live" className="unit-type-label" onClick={(e) => {this.changeClass(2, 'live')}}>Live Unit</label>
                                    </div>
                            </div>
                            <div className="unit-type-container" style={this.state.showCreativeTypes !== 3 ? {alignItems: 'flex-start'} : {}}>
                                <p className="unit--label-style unit--one-label">Creative Format</p>
                                {this.state.showCreativeTypes === 3 && <p className="unit--label-style">Please select a Unit Type to see options</p>}
                                {this.state.showCreativeTypes === 1 && <ul className="creative--type-list-mock">
                                    {this.state.inputOptions.creative_types.filter(v => v.unit_type === 'mock').sort(function (a, b) {
                                            if (a.name < b.name) {
                                                return -1;
                                            }
                                            if (a.name > b.name) {
                                                return 1;
                                            }
                                            return 0;
                                        }).map(item => (
                                            <li key={item.id}>
                                                <input type="radio"
                                                       disabled={this.getUnitType() === 'live' && !this.props.create}
                                                       name="creative_type_id"
                                                       onChange={this.handleRadioChange}
                                                       value={item.id}
                                                       id={item.id}
                                                       checked={this.state.inputValues.creative_type_id === item.id}
                                                       />
                                                <label htmlFor={item.id}>{item.name}</label>
                                            </li>
                                        ))
                                    }
                                </ul>}
                                {this.state.showCreativeTypes === 2 && <ul className="creative--type-list-live">
                                    {this.state.inputOptions.creative_types.filter(v => v.unit_type === 'live').sort(function (a, b) {
                                            if (a.name < b.name) {
                                                return -1;
                                            }
                                            if (a.name > b.name) {
                                                return 1;
                                            }
                                            return 0;
                                        }).map(item => (
                                            <li key={item.id}>
                                                <input type="radio"
                                                       disabled={this.getUnitType() === 'mock' && !this.props.create}
                                                       name="creative_type_id"
                                                       onChange={this.handleRadioChange}
                                                       value={item.id}
                                                       id={item.id}
                                                       checked={this.state.inputValues.creative_type_id === item.id}
                                                       />
                                                <label htmlFor={item.id}>{item.name}</label>
                                            </li>
                                        ))
                                    }
                                </ul>}
                            </div>
                            <div className="button-wrapper unit-picking-button-container">
                                <button className="button button--transparent"
                                        onClick={() => this.props.toggleModal('unit', false)}>Cancel
                                </button>
                                {this.props.flow && <button className="button button--transparent"
                                        onClick={() => {this.changeStep(1); this.props.changeSteps(1)}}>Back
                                </button>}
                                <button className="button button--blue"
                                        onClick={() => this.changeStep(2)}>Next
                                </button>
                            </div>
                        </div>
                        <div style={{display: this.state.step === 2 ? 'block' : 'none'}}>
                            <div className="modal-header">
                                <h1>{this.props.create ? 'Add Creative' : 'Edit Creative'}</h1>
                                <div className="creative-type">
                                    {campaign.name}: {this.getUnitType()} Unit, {this.getCreativeType()}
                                </div>
                            </div>
                            <div className="first-row row-border">
                                <p className="col--unit-header">Thumbnail Details</p>
                                <div className="input-wrapper first-col1">
                                    <div className="input-wrapper">
                                        <div className="input--column-2">
                                            <div className="second--row-input-wrapper">
                                                <label>Preview Thumbnail<span className="required--fields">*</span></label>
                                                <div className="second--row-inner first-row-col-2">
                                                    <label htmlFor="files" className="file-upload-btn">
                                                        <input name="unit[thumbnail]" type="file" id='files' className="hiddenMenu" onChange={this.handleImageChange} />
                                                        Browse</label>
                                                    <span className="file--upload-text">{values.thumbnail_name ? values.thumbnail_name : "Choose jpg, png, or gif file" }</span>
                                                </div>
                                            </div>
                                            <div className="second--row-input-wrapper">
                                                <label className="preview-thumb-label">Preview Thumbnail Device<span className="required--fields">*</span></label>
                                                <div className="second--row-inner">
                                                    <ul>
                                                        {this.getThumbnailDevices()}
                                                    </ul>
                                                </div>
                                            </div>
                                            <label className="file--anchor">Choose alternative thumbnail
                                                <input type="file" name="thumbnail_alt" id="file_input_id" onChange={this.handleFileChange}/>
                                            </label>
                                        </div>
                                        <div className="input--column-3">
                                            <label className="file--thumbnail">Thumbnail Preview
                                                <input name="unit[thumbnail]" type="file" id='files' className="hiddenMenu" onChange={this.handleImageChange} />
                                                {values.thumbnail_url !== false &&
                                                    <img src={values.thumbnail_url} alt="thumbnail"
                                                         className="preview-img"/>
                                                }
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second--row row-border">
                                <p className="col--unit-header">Creative Details</p>
                                <div className="first-col1">
                                    <div className="input-wrapper">
                                        <div className="input--column-2">
                                            <div>
                                            {this.getUnitType() === 'mock' &&
                                                <div className="device-wrapper">
                                                    <label>Mocked Devices<span className="required--fields">*</span></label>
                                                    <ul>
                                                        {this.state.inputValues.creative_type_id  === 501 &&
                                                            <React.Fragment>
                                                                <li><label><input defaultChecked={this.state.inputValues.roadside_billboard === "true"}
                                                                                  type="checkbox" name="devices" value="roadside_billboard"
                                                                                  onChange={this.handleMultiCheckboxChange}/>Roadside Billboard</label>
                                                                </li>
                                                                    <li><label><input defaultChecked={this.state.inputValues.commuter_hub === "true"}
                                                                                      type="checkbox" name="devices" value="commuter_hub"
                                                                                      onChange={this.handleMultiCheckboxChange}/>Commuter Hub</label>
                                                                    </li>
                                                                </React.Fragment>
                                                            }
                                                        {this.state.inputValues.creative_type_id  !== 501 &&
                                                            <React.Fragment>
                                                                {this.state.inputValues.creative_type_id  === 505 &&
                                                                    <li><label><input defaultChecked={this.state.inputValues.phone === "true"}
                                                                                      type="checkbox" name="devices" value="phone"
                                                                                      onChange={this.handleCheckboxChange}/> Phone</label></li>
                                                                }
                                                                {this.state.inputValues.creative_type_id  !== 505 &&
                                                                    <React.Fragment>
                                                                        <li><label><input defaultChecked={this.state.inputValues.phone === "true"}
                                                                                          type="checkbox" name="devices" value="phone"
                                                                                          onChange={this.handleMultiCheckboxChange}/> Phone</label></li>
                                                                        <li><label><input defaultChecked={this.state.inputValues.tablet === "true"}
                                                                                          type="checkbox" name="devices" value="tablet"
                                                                                          onChange={this.handleMultiCheckboxChange}/> Tablet</label></li>
                                                                        <li><label><input defaultChecked={this.state.inputValues.desktop === "true"}
                                                                                          type="checkbox" name="devices" value="desktop"
                                                                                          onChange={this.handleMultiCheckboxChange}/> Desktop</label>
                                                                        </li>
                                                                    </React.Fragment>
                                                                }
                                                                {this.state.inputValues.creative_type_id  === 3 &&
                                                                    <li><label><input defaultChecked={this.state.inputValues.ctv === "true"}
                                                                                      type="checkbox" name="devices" value="ctv"
                                                                                      onChange={this.handleMultiCheckboxChange}/> CTV</label>
                                                                    </li>
                                                                }
                                                            </React.Fragment>
                                                        }
                                                        </ul>
                                                    </div>
                                            }
                                            {this.getUnitType() === 'mock' &&
                                                <div className="second--row-input-wrapper">
                                                    <label htmlFor='powerpoint-files'>Powerpoint File<span className="required--fields">*</span></label>
                                                    <div className="second--row-inner">
                                                        <label htmlFor="powerpoint-files" className="file-upload-btn">
                                                            <input type="file" name="powerpoint" id="powerpoint-files" className="hiddenMenu" onChange={this.handleFileChange}/>
                                                            Browse</label>
                                                        {/*{values.powerpoint_url !== false &&*/}
                                                        {/*    <a href={values.powerpoint_url} target="_blank"*/}
                                                        {/*       rel="noopener noreferrer"*/}
                                                        {/*       className="external-icon">*/}
                                                        {/*        <SVG src={externalIcon}/>*/}
                                                        {/*    </a>*/}
                                                        {/*}*/}
                                                        <span className="file--upload-text">{values.powerpoint_name ? values.powerpoint_name : "Choose ppt file"}</span>
                                                    </div>
                                                </div>
                                            }

                                           <div className="second--row-input-wrapper">
                                               <label>Designer<span className="required--fields">*</span></label>
                                               <div className="second--row-inner">
                                                   <Select
                                                        autoComplete="off"
                                                        onChange={this.handleSelectChange('designer')}
                                                        options={this.state.inputOptions.designers}
                                                        value={this.state.inputValues.designer}
                                                        onKeyDown={this.handleKeyDown('designer')}
                                                        className="react-select"
                                                        classNamePrefix="react-select--dd"
                                                    />
                                               </div>
                                           </div>
                                            <div className="second--row-input-wrapper">
                                                <label>Date<span className="required--fields">*</span></label>
                                                <div className="second--row-inner">
                                                    <Datetime
                                                    dateFormat={"MMMM YYYY"}
                                                    value={this.state.inputValues.date_format}
                                                    defaultValue={this.state.inputValues.date_format}
                                                    className="form-control"
                                                    name="date"
                                                    onChange={moment => this.handleDateChange(moment, 'date')}
                                                    inputProps={{readOnly: true}}
                                                    closeOnSelect={true}
                                                    />
                                                </div>
                                            </div>
                                            {this.getUnitType() === 'live' && this.getCreativeType() !== 'Display' && this.getCreativeType() !== 'Digital Out Of Home' && this.getCreativeType() !== 'Augmented Reality' && this.getCreativeType() !== 'Native High Impact' &&
                                                <div className="second--row-input-wrapper">
                                                    <label>Celtra Campaign Link<span className="required--fields">*</span></label>
                                                    <div className="second--row-inner">
                                                        <input name="celtra_url" onChange={this.handleTextChange}
                                                           className="form-control" defaultValue={values.celtra_url}/>
                                                    </div>
                                                </div>
                                            }
                                            {this.getUnitType() === 'live' &&
                                                <div className="second--row-input-wrapper">
                                                    <label>JIRA Ticket Link<span className="required--fields">*</span></label>
                                                    <div className="second--row-inner">
                                                        <input name="jira_url" onChange={this.handleTextChange}
                                                           className="form-control" placeholder="https://adtheorent.atlassian.net/jira/" defaultValue={values.jira_url}/>
                                                    </div>
                                                </div>
                                            }
                                            {this.getUnitType() === 'live' &&
                                                <div className="second--row-input-wrapper">
                                                    <label>Salesforce ID<span className="required--fields">*</span></label>
                                                    <div className="second--row-inner">
                                                        <input type="text" name="sf_id" pattern="[0-9]*" value={values.sf_id !== "" ? values.sf_id : ""} onChange={(e) => this.handleTextChange(e)}
                                                           className="form-control" placeholder="000000"/>
                                                    </div>
                                                </div>
                                            }
                                            {this.getUnitType() === 'live' &&
                                                <div className="second--row-input-wrapper">
                                                    <label htmlFor="creative_refresh" id="creative_refresh">Creative Refresh? </label>
                                                    <div className="second--row-inner">
                                                        <input type="checkbox" name="creative_refresh" defaultChecked={values.creative_refresh === 'true'} onChange={this.handleCheckboxChange}/>
                                                    </div>
                                                </div>

                                            }
                                                {this.getUnitType() === 'live' &&
                                                    <div className="second--row-input-wrapper">
                                                        <label htmlFor='powerpoint-files'>Live Powerpoint File</label>
                                                        <div className="second--row-inner">
                                                            <label htmlFor='powerpoint-files' className="file-upload-btn">
                                                                <input type="file" name="powerpoint" id="powerpoint-files" className="hiddenMenu"
                                                                       onChange={this.handleFileChange}/>Browse
                                                                {/*{values.powerpoint_url !== false && values.powerpoint_url !== null &&*/}
                                                                {/*    <div style={{display: "inline"}}>*/}
                                                                {/*        <a href={values.powerpoint_url} target="_blank"*/}
                                                                {/*           rel="noopener noreferrer"*/}
                                                                {/*           className="external-icon">*/}
                                                                {/*            <SVG src={externalIcon}/>*/}
                                                                {/*        </a>*/}
                                                                {/*        <span className="trash-unit-icon"*/}
                                                                {/*              onClick={() => this.deleteS3('p')}><SVG*/}
                                                                {/*            src={trashCan}/></span>*/}
                                                                {/*    </div>*/}
                                                                {/*}*/}
                                                            </label>
                                                            <span className="file--upload-text">{values.powerpoint_name ? values.powerpoint_name : "Choose ppt file"}</span>
                                                        </div>
                                                    </div>
                                                }
                                            {this.getUnitType() === 'mock' &&
                                                <div className="jira--input-wrapper">
                                                    <label>EPIC ID<span className="required--fields">*</span></label>
                                                    <div className="second--row-inner">
                                                        <span>CAM2 -</span><input type="text" name="epic_id" disabled={values.default_epic_id === 1 || values.default_epic_id === true} value={values.epic_id !== null ? values.epic_id.replace(base,""): ""} onChange={this.handleTextChange}
                                                               className="form-control"  placeholder="00000"/>
                                                        <div className="second--row-label-container">
                                                            <input defaultChecked={values.default_epic_id === 1}
                                                                   type="checkbox" name="default_epic_id" value="true"
                                                                   onChange={this.changeEpicId}/>
                                                            <label>Use Miscellaneous Proactive EPIC ID</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {this.getUnitType() === 'mock' &&
                                                <div className="second--row-input-wrapper last-row">
                                                        <label>Creative Assets</label>
                                                    <div className="second--row-inner">
                                                        <input name="creative_assets" onChange={this.handleTextChange}
                                                           className="form-control" defaultValue={values.creative_assets_url}/>
                                                    </div>
                                                </div>
                                            }
                                                {/*<div className="first-col3">*/}
                                                {/*    {this.getUnitType() === 'live' && this.state.inputValues.creative_type_id == 11 &&*/}
                                                {/*        <div className="input-wrapper">*/}
                                                {/*            <label>Yieldmo Campaign Link</label>*/}
                                                {/*            <input name="yieldmo_url" onChange={this.handleTextChange}*/}
                                                {/*                   className="form-control" defaultValue={values.yieldmo_url}/>*/}
                                                {/*        </div>*/}
                                                {/*    }*/}
                                                {/*</div>*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="third--row row-border">
                                <p className="col--unit-header">Functionality <br/> <span className="col--header-span">Select All That Apply</span><span className="required--fields">*</span></p>
                                <div className="functionality " style={{position: 'relative'}}>
                                    <ul>
                                        {this.state.inputOptions.functionalities.filter((f) => {
                                            if(f.creative_type_id === this.state.inputValues.creative_type_id){
                                                if(f.creative_type_id === 1 || f.creative_type_id === 7 || f.creative_type_id === 8 ){
                                                    if(f.name !== "Expandable" && f.name !== "Interstitial"){
                                                        return f
                                                    }
                                                }else{
                                                    return f
                                                }
                                            }
                                        }).map((functionality) => {
                                            return (<li key={functionality.id}>
                                                {values.creative_type_id === 504 && functionality.name === "Gamification" || values.creative_type_id === 505 && functionality.name === "Gamification" ?
                                                        <label>
                                                            <ToolTips content="All AR Creatives are gamification" data="ar">
                                                            <input
                                                                type="checkbox"
                                                                name="functionalities"
                                                                value={functionality.id}
                                                                disabled={true}
                                                                checked={true}
                                                                onChange={this.handleMultiCheckboxChange}/> {functionality.name}
                                                            </ToolTips>
                                                        </label>
                                                    : <label>
                                                <input
                                                    type="checkbox"
                                                    name="functionalities"
                                                    value={functionality.id}
                                                    // disabled={values.creative_type_id === 504 && functionality.name === "Gamification" || values.creative_type_id === 505 && functionality.name === "Gamification"}
                                                    checked={values.functionalities.includes(functionality.id)}
                                                    onChange={this.handleMultiCheckboxChange}/> {functionality.name}
                                            </label>}
                                            </li>)
                                        })}
                                    </ul>
                                </div>
                            </div>
                            {/*<div className="second--row-input-wrapper">*/}
                            {/*    <label>Primary Functionality</label>*/}
                            {/*    <div className="second--row-inner">*/}
                            {/*        <input name="media_label" onChange={this.handleTextChange}*/}
                            {/*               className="form-control" defaultValue={values.media_label}/>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {this.filterMediaLabelOptions()}
                            <div className="third--row fourth--row row-border device-options-container">
                                <p className="col--unit-header">Additional Features Select <br/> <span className="col--header-span">Select All That Apply</span></p>
                                <div>
                                    {this.getUnitType() === 'mock' && <ul>
                                        <li><label><input
                                            defaultChecked={this.state.inputValues.animated === "true"}
                                            type="checkbox" name="animated" value="true"
                                            onChange={this.handleCheckboxChange}/>Animated Mock</label>
                                        </li>
                                        {this.state.inputValues.creative_type_id  === 1 &&
                                            <li><label><input
                                                defaultChecked={this.state.inputValues.unexpanded_banner === "true"}
                                                type="checkbox" name="unexpanded_banner" value="true"
                                                onChange={this.handleCheckboxChange}/> Unexpanded Banner</label>
                                            </li>
                                        }
                                        <li><label><input
                                            defaultChecked={this.state.inputValues.proactive_proposal === "true"}
                                            type="checkbox" name="proactive_proposal" value="true"
                                            onChange={this.handleCheckboxChange}/> Proactive Proposal</label>
                                        </li>
                                    </ul>}
                                    <ul>
                                        {this.state.inputOptions.creative_subcategories.map((cs) => {
                                            return (<li key={cs.id}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        name="creative_subcategories"
                                                        value={cs.id}
                                                        checked={values.creative_subcategories.includes(cs.id)}
                                                        onChange={this.handleMultiCheckboxChange}/> {cs.name}
                                                </label>
                                            </li>)
                                        })}
                                    </ul>
                                </div>
                            </div>
                            {this.getUnitType() === 'live' &&
                                <div className={`${this.getCreativeType() !== 'Display ' ? '' : ''} fourth--row unit-demo`}>
                                    <div className="device-header">
                                        <label className={`device-run-on ${!type ? 'no-creative-id' : ''}`}>{values.creative_type_id === 10 ||  values.meta_data.meta_value !== "link" ? "Ad Size" : "Devices Run On" }</label>
                                        {/*{this.ifBulk() === true ?*/}
                                        {/*    <label className="tm">File Uploaded</label>*/}
                                        {/*    :*/}
                                        {/*    ()}*/}
                                        {type && <label className="creative-id">Creative ID</label>}
                                        <label className={`demolinks ${!type ? 'no-creative-id' : ''}`}>Demo Link</label>
                                        <label className={`notes ${!type ? 'no-creative-id' : ''}`}>Notes</label>
                                        <label className="best-in-class">Best in Class</label>
                                    </div>

                                    {values.demo_links.map((link, key) => (
                                            <div className="demo_row" key={key}>
                                                <div className="inner-container-drop">
                                                    <Select
                                                        autoComplete="off"
                                                        onChange={this.handleSelectChange('demo_links', key, 'demo_type')}
                                                        options={this.getDemoType().filter(dt => {
                                                            if (this.state.inputValues.creative_type_id !== 2 && this.state.inputValues.creative_type_id !== 499) {
                                                                if (dt.value === 4) {
                                                                    return false;
                                                                }
                                                            }
                                                            return true;
                                                        })}
                                                        value={link.demo_type}
                                                        onKeyDown={this.handleKeyDown('demo_links')}
                                                        className="react-select"
                                                        classNamePrefix="react-select--dd"
                                                    />
                                                </div>
                                                {type && <div className="inner-container-creative-id">
                                                        <input type="text" name="demo_links" value={link.creative_id !== null || typeof(link.creative_id) !== 'object' ? link.creative_id : ""}
                                                           onChange={(e) => this.handleTextChange(e, key, 'creative_id')}/>
                                                </div>}
                                                <div className="inner-container-url">
                                                    <input type="text" name="demo_links" value={link.url}
                                                           onChange={(e) => this.handleTextChange(e, key, 'url')}/>
                                                </div>
                                                <div className="inner-container-notes">
                                                    <input type="text" name="demo_links" value={link.notes}
                                                           onChange={(e) => this.handleTextChange(e, key, 'notes')}/>
                                                </div>
                                                <div className="inner-container-best-in-class">
                                                    <button name="demo_links" onClick={(e) => { this.addToFavorites(e, key, 'bestInClass') }} style={link.bestInClass === 1 ? {background: "#e1ca6c", borderColor: "transparent"} : {background: "#ffffff"}} className="favorite-btn"><img src={link.bestInClass === 1 ? whiteStar: greyStar} className="grey-star" alt="grey-star"/></button>
                                                </div>
                                                <div className="inner-container-button">
                                                    <div className="circle-button">
                                                            <span onClick={() => this.deleteDemoRow(key)}>
                                                                <SVG src={minusIcon}/>
                                                            </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    <div className="circle-button circle-button--grey">
                                        <span className="isvg" onClick={this.addDemoRow}>
                                            <SVG src={plusIcon}/>
                                        </span>
                                    </div>
                                    {ct &&
                                        <div className="input-wrapper">
                                            <label htmlFor="count_box">
                                                Count Box:
                                                <input type="number" className="form-control count_box" name="count_box" value={values.count_box} onChange={this.handleTextChange}/>
                                            </label>
                                        </div>
                                    }
                                </div>
                            }
                            <div className="button-wrapper">
                                {this.props.create &&
                                <React.Fragment>
                                    <button type="button" className="button button--transparent"
                                            onClick={() => {this.changeStep(1); this.props.changeSteps(2)}}>Back
                                    </button>
                                    <button type="button" className="button button--black"
                                            onClick={() => this.handleSave(false)}>Create
                                    </button>
                                    <button type="button" className="button button--blue"
                                            onClick={() => this.handleSave(true)}>Save & Add New
                                    </button>
                                </React.Fragment>
                                }
                                {!this.props.create &&
                                <React.Fragment>
                                    <button type="button" className="button button--transparent"
                                            onClick={() => this.changeStep(1)}>Back
                                    </button>
                                    <button type="button" className="button button--red-outline"
                                            onClick={this.handleDelete}>Delete
                                    </button>
                                    <button type="button" className="button button--black"
                                            onClick={() => this.handleSave(true)}>Save
                                    </button>
                                </React.Fragment>
                                }
                            </div>
                        </div>
                    </form>
                </div>
                {this.props.loading && <div className="loading-mask">
                    <Loading/>
                </div>}
            </React.Fragment>
        )
    }
}
export default withRouter(connect(null)(UnitModal));
